import React from "react";
import Loading from './../components/loading';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import ListGroup from 'react-bootstrap/ListGroup'
import Image from 'react-bootstrap/Image'
import Nav from 'react-bootstrap/Nav'
import { Slide } from 'react-reveal';

class GuideHome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            menuerror: null,
            menuisLoaded: false,
            menuitems: []
        };
    }

    componentDidMount() {
        fetch("/json/categories.json?v=" + process.env.REACT_APP_SITE_VERSION)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )

        fetch("/json/content.json?v=" + process.env.REACT_APP_SITE_VERSION)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        menuisLoaded: true,
                        menuitems: result
                    });
                },
                (menuerror) => {
                    this.setState({
                        menuisLoaded: true,
                        menuerror
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;
        const { menuerror, menuisLoaded, menuitems } = this.state;
        if (error || menuerror) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded || !menuisLoaded) {
            return <Loading />;
        } else {
            return (
                <>
                    {
                        items.filter(items => items.guid === window.location.pathname).map((category, i) => {
                            return (
                                <div key={i}>
                                    <Jumbotron className="subpageHeader" fluid>
                                        <Container>
                                            <h1>{category.name}</h1>
                                            <Breadcrumb>
                                                <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                                                <Breadcrumb.Item active>{category.name}</Breadcrumb.Item>
                                            </Breadcrumb>
                                        </Container>
                                    </Jumbotron>
                                    <section className="categoryTheme">
                                        <Container>
                                            <Row>
                                                <Col className="subpageContent">
                                                    <h2>{category.name}</h2>
                                                    <ListGroup variant="flush">

                                                        {
                                                            menuitems.filter(menuitems => menuitems.category === category.name).map((subitems, i) => {
                                                                return (

                                                                    <ListGroup.Item key={i}>
                                                                        <Slide bottom cascade>
                                                                            <Row className="mb-3 mt-3">
                                                                                <Col md={3}>
                                                                                    <Image src={subitems.thumb} alt={subitems.name} fluid />
                                                                                </Col>
                                                                                <Col>
                                                                                    <h3 className="mt-4 mb-3">{subitems.name}</h3>
                                                                                    <p className="mb-4">{subitems.summary}</p>
                                                                                    <Nav.Link href={`${category.guid}/${subitems.permalink}`}>Detaylı Bilgi</Nav.Link>
                                                                                </Col>
                                                                            </Row>
                                                                        </Slide>
                                                                    </ListGroup.Item>
                                                                );
                                                            })
                                                        }
                                                    </ListGroup>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </section>
                                </div>
                            )
                        }
                        )
                    }
                </>
            );
        }
    }
}

export default GuideHome;